import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchHeroes } from '../../actions/tenantStats';
import Logger from '../../util/Logger';
import User from '../../models/User';
import DateTime from '../../models/DateTime';
import TenantHero from '../../models/TenantHero';
import { AnalyticsCardHeader } from './AnalyticsCardHeader';
import SearchBox from '../shared/SearchBox';
import './ActiveHeroes.css';
import popSearch from '../../services/pop-search';
import { HeroSorts } from '../../util/HeroSorts';
import Tenant from '../../models/Tenant';
import LoadingAndPulse from '../shared/LoadingAndPulse.jsx';
import { UserAvatar } from '../shared/UserAvatar';
import '../shared/UserAvatar.css';
import Tooltip from '../shared/Tooltip';
import { arrowDownIcon, arrowUpIcon } from '../../constants';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { handleError } from '../../util/Errors';
import EmptyState from '../shared/EmptyState';
import EmptyStateIcon from '../../images/creator_empty_state.svg';
import { EnterpriseAnalytics } from '../../analytics/EnterpriseAnalytics';

const Sorts = {
  NAME_ASCENDING: 'name',
  NAME_DESCENDING: 'name_reverse',
  EMAIL_ASCENDING: 'email',
  EMAIL_DESCENDING: 'email_reverse',
  POPINS_ASCENDING: 'popins',
  POPINS_DESCENDING: 'popins_reverse',
  REACH_ASCENDING: 'reach',
  REACH_DESCENDING: 'reach_reverse',
  LAST_POPIN_ASCENDING: 'last_popin',
  LAST_POPIN_DESCENDING: 'last_popin_reverse'
};

class ActiveHeroes extends Component {

  handleSortByName = () => {
    const newSort = !this.state.nameSortReversed;
    EnterpriseAnalytics.sortsCreatorsByName();
    this.setState({
      nameSortReversed: newSort,
      activeSort: newSort ? Sorts.NAME_DESCENDING : Sorts.NAME_ASCENDING
    });
  };
  handleSortByEmail = () => {
    const newSort = !this.state.emailSortReversed;
    EnterpriseAnalytics.sortsCreatorsByEmail();
    this.setState({
      emailSortReversed: newSort,
      activeSort: newSort ? Sorts.EMAIL_DESCENDING : Sorts.EMAIL_ASCENDING
    });
  };
  handleSortByPopins = () => {
    const newSort = !this.state.popinsSortReversed;
    EnterpriseAnalytics.sortsCreatorsByPopins();
    this.setState({
      popinsSortReversed: newSort,
      activeSort: newSort ? Sorts.POPINS_DESCENDING : Sorts.POPINS_ASCENDING
    });
  };
  handleSortByReach = () => {
    const newSort = !this.state.reachSortReversed;
    EnterpriseAnalytics.sortsCreatorsByReach();
    this.setState({
      reachSortReversed: newSort,
      activeSort: newSort ? Sorts.REACH_DESCENDING : Sorts.REACH_ASCENDING
    });
  };
  handleSortByLastPopin = () => {
    const newSort = !this.state.lastPopinSortReversed;
    EnterpriseAnalytics.sortsCreatorsByLastPopin();
    this.setState({
      lastPopinSortReversed: newSort,
      activeSort: newSort ? Sorts.LAST_POPIN_DESCENDING : Sorts.LAST_POPIN_ASCENDING
    });
  };
  formatHeroes = (heroes) => {
    return heroes.map((hero) => {
      const id = TenantHero.getId(hero);
      const name = TenantHero.getName(hero);
      const email = TenantHero.getEmail(hero);
      const popins = TenantHero.getPopins(hero);
      const reach = TenantHero.getReach(hero);
      const lastTime = TenantHero.getLastPopin(hero);
      const lastPopin = (lastTime === null)
        ? 'Not Available'
        : DateTime.format(DateTime.unixSecondsToMoment(lastTime), 'MMM D, YYYY');
      return [id, name, email, popins, reach, lastPopin, hero];
    });
  };
  sortHeroes = (heroes) => {
    switch (this.state.activeSort) {
      case Sorts.NAME_ASCENDING:
        return HeroSorts.copySortedByName(heroes);
      case Sorts.NAME_DESCENDING:
        return HeroSorts.copySortedByName(heroes, true);
      case Sorts.EMAIL_ASCENDING:
        return HeroSorts.copySortedByEmail(heroes);
      case Sorts.EMAIL_DESCENDING:
        return HeroSorts.copySortedByEmail(heroes, true);
      case Sorts.POPINS_ASCENDING:
        return HeroSorts.copySortedByPopins(heroes);
      case Sorts.POPINS_DESCENDING:
        return HeroSorts.copySortedByPopins(heroes, true);
      case Sorts.REACH_ASCENDING:
        return HeroSorts.copySortedByReach(heroes);
      case Sorts.REACH_DESCENDING:
        return HeroSorts.copySortedByReach(heroes, true);
      case Sorts.LAST_POPIN_ASCENDING:
        return HeroSorts.copySortedByLastPopin(heroes);
      case Sorts.LAST_POPIN_DESCENDING:
        return HeroSorts.copySortedByLastPopin(heroes, true);
      default:
        Logger.assert(`Invalid sort: ${this.state.activeSort}`);
    }

  };
  filterHeroes = (heroes) => {
    return popSearch.filterArraysOfStrings(heroes, this.state.searchTerm);
  };
  getHeroes = () => {
    const { heroes } = this.props;
    if (heroes) {

      const sorted = this.sortHeroes(heroes);
      const formatted = this.formatHeroes(sorted);
      return this.filterHeroes(formatted);
    }
  };
  updateSearchFilter = (searchTerm) => {
    EnterpriseAnalytics.searchedCreators();
    this.setState({ searchTerm: searchTerm });
  };

  constructor (props) {
    super(props);

    this.state = {
      activeSort: Sorts.NAME_ASCENDING,
      nameSortReversed: false,
      emailSortReversed: false,
      searchTerm: ''
    };
  }

  fetchCreators = () => {
    const { user, fetchHeroes, dateRange } = this.props;
    fetchHeroes(Tenant.getId(User.getTenant(user)), dateRange.value);
  };

  componentDidMount () {
    this.fetchCreators();
  }

  componentDidUpdate (prevProps) {
    const { dateRange, heroesError } = this.props;
    if (prevProps.dateRange.value !== dateRange.value) {
      this.fetchCreators();
    }

    handleError(heroesError, prevProps.heroesError);
  };

  render () {
    const { searchTerm } = this.state;
    const { loading, heroesTotal, dateRange, heroesError } = this.props;
    const heroesToDisplay = this.getHeroes();
    const isNameSortActive = (
      this.state.activeSort === Sorts.NAME_ASCENDING ||
      this.state.activeSort === Sorts.NAME_DESCENDING
    );
    const isEmailSortActive = (
      this.state.activeSort === Sorts.EMAIL_ASCENDING ||
      this.state.activeSort === Sorts.EMAIL_DESCENDING
    );
    const isPopinsSortActive = (
      this.state.activeSort === Sorts.POPINS_ASCENDING ||
      this.state.activeSort === Sorts.POPINS_DESCENDING
    );
    const isReachSortActive = (
      this.state.activeSort === Sorts.REACH_ASCENDING ||
      this.state.activeSort === Sorts.REACH_DESCENDING
    );
    const isLastPopinSortActive = (
      this.state.activeSort === Sorts.LAST_POPIN_ASCENDING ||
      this.state.activeSort === Sorts.LAST_POPIN_DESCENDING
    );
    return (
      <div className="card analytics-card-height card-active-heroes">
        <div className="row fix-ie-when-small">
          <div className="col-lg-8">
            <AnalyticsCardHeader
              icon="person"
              count={ loading
                ? null
                : heroesTotal
                  ? heroesTotal
                  : null }
              title="POPin CREATORS"
              dateRange={ dateRange } />
          </div>
          <div className="col-lg-4 clearfix fix-ie">
            <div className="float-right fix-ie">
              <SearchBox updateSearchFilter={ this.updateSearchFilter } />
            </div>
          </div>
        </div>

        <div className="heroes-table">
          <div className="row heroes-header heroes-list-item">
            <div className="name">
              <span className="clickable" onClick={ this.handleSortByName }>Name</span>
              <i
                onClick={ this.handleSortByName }
                className={ `material-icons clickable ${isNameSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.nameSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="email">
              <span className="clickable" onClick={ this.handleSortByEmail }>Email</span>
              <i
                onClick={ this.handleSortByEmail }
                className={ `material-icons clickable ${isEmailSortActive
                  ? 'enabled-icon'
                  : 'disabled-icon'}` }>
                { this.state.emailSortReversed ? arrowUpIcon : arrowDownIcon }
              </i>
            </div>
            <div className="popins">
              <Tooltip tooltip="All POPins active, upcoming, or completed by a given POPin Creator.">
                <div className="popins">
                  <span className="clickable" onClick={ this.handleSortByPopins }>POPins</span>
                  <i
                    onClick={ this.handleSortByPopins }
                    className={ `material-icons clickable ${isPopinsSortActive
                      ? 'enabled-icon'
                      : 'disabled-icon'}` }>
                    { this.state.popinsSortReversed ? arrowUpIcon : arrowDownIcon }
                  </i>
                </div>
              </Tooltip>
            </div>
            <div className="reach">
              <Tooltip tooltip="All users who viewed at least one POPin started by a given POPin Creator.">
                <div className="reach">
                  <span className="clickable" onClick={ this.handleSortByReach }>Reach</span>
                  <i
                    onClick={ this.handleSortByReach }
                    className={ `material-icons clickable ${isReachSortActive
                      ? 'enabled-icon'
                      : 'disabled-icon'}` }>
                    { this.state.reachSortReversed ? arrowUpIcon : arrowDownIcon }
                  </i>
                </div>
              </Tooltip>
            </div>
            <div className="last-popin">
              <Tooltip tooltip="Start date of the most recent POPin by a given POPin Creator.">
                <div className="last-popin">
                  <span
                    className="clickable"
                    onClick={ this.handleSortByLastPopin }>Last POPin</span>
                  <i
                    onClick={ this.handleSortByLastPopin }
                    className={ `material-icons clickable ${isLastPopinSortActive
                      ? 'enabled-icon'
                      : 'disabled-icon'}` }>
                    { this.state.lastPopinSortReversed ? arrowUpIcon : arrowDownIcon }
                  </i>
                </div>
              </Tooltip>
            </div>
          </div>
          { heroesError ?
            (
              <div className="heroes-list">
                <ErrorAndRefresh
                  error="Failed to load POPin Creators"
                  onRefresh={ this.fetchCreators } />
              </div>
            )
            : loading
              ?
              <div className="heroes-list">
                <LoadingAndPulse
                  size={ 20 }
                  color="#3D9AE2"
                  whatIsLoading="POPin creators" />
              </div>
              : (heroesToDisplay && heroesToDisplay.length > 0)
                ? (
                  <div className="heroes-list-container">
                    <div className="col heroes-list">
                      { heroesToDisplay.map(h => <HeroListItem key={ h[0] } hero={ h } />) }
                    </div>
                  </div>

                ) : searchTerm
                  ? (
                    <div className="heroes-list">
                      <div className="my-5">
                        <EmptyState
                          image={ null }
                          title="No Search Results"
                          message="Try again with a different search term."
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="heroes-list">
                      <div className="my-5">
                        <EmptyState
                          image={ EmptyStateIcon }
                          title="Waiting for Brave Souls"
                          message="Once a creator launches a POPin, you'll see them here"
                        />
                      </div>
                    </div>
                  )
          }
        </div>
      </div>
    );
  }
}

const HeroListItem = ({ hero }) => {
  const name = hero[1];
  const popins = hero[3];
  const reach = hero[4];
  const lastPopin = hero[5];
  const fullHero = hero[6];
  return (
    <div className="row heroes-list-item list-item py-1">
      <div className="name">{ name }</div>
      <div className="email">
        <UserAvatar user={ fullHero } />
      </div>
      <div className="popins my-auto">{ popins }</div>
      <div className="reach my-auto">{ reach }</div>
      <div className="last-popin my-auto">{ lastPopin }</div>
    </div>
  );
};

ActiveHeroes.propTypes = {};
ActiveHeroes.defaultProps = {};

const mapStateToProps = state => {
  return {
    user: state.user.user,
    loading: state.tenantStats.heroesLoading,
    heroes: state.tenantStats.heroes,
    heroesTotal: state.tenantStats.heroesTotal,
    heroesError: state.tenantStats.heroesError
  };
};

export default connect(mapStateToProps, { fetchHeroes })(ActiveHeroes);
